export class tradebookModel {
setValue(res){
if(res){
}
}
}